<template>
    <div class="container py-5">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/dashboard">Admin Dashboard</router-link></li>
                <li class="breadcrumb-item active" aria-current="page">Skin stories</li>
            </ol>
        </nav>
        <div class="row justify-content-between">
            <div class="col-4">
                <h1>Skin Stories</h1>
            </div>
            <div class="col-4 d-md-flex justify-content-md-end">
                <div>
                    <router-link to="adminskinstory" class="btn btn-success mx-1">Add</router-link>
                </div>
            </div>
        </div>

        <div class="row">
            <div v-if="!loaded" class="d-flex justify-content-center">
                <div class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>
            <div v-else class="list-group list-group-numbered">
                <div v-for="item in skinstories" :key="item.id" class="list-group-item list-group-item-action">
                    <div class="d-flex w-100 justify-content-between">
                        <h5 class="mb-1">{{item.name}}</h5>
                        <div>
                            <span v-if="item.isDraft"><i class="bi bi-exclamation-diamond mx-1" style="color:red"></i> draft</span>
                            <router-link :to="{ path: 'adminskinstory', query: { id: item.id } }" class="btn btn-warning mx-1">Edit</router-link>
                            <button @click.stop.prevent="openDeleteModal(item)" type="button" class="btn btn-danger mx-1">Delete</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal" ref="modal" id="dialogYesNo" tabindex="-1">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Skin Atlas</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <p>Are you sure you want to delete item: {{selectedItem?.name}}</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                        <button type="button" @click="deleteItem(selectedItem)" data-bs-dismiss="modal" class="btn btn-danger"> Yes </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from "axios";
    import { authHeader } from '@/services/authHeader.js';
    import { toastOptions } from '@/helpers/toastOptions.js';
    import Modal from 'bootstrap/js/dist/modal';

    //let selectedItem = { id: 0, name: "" };
    let skinstories = [];
    let loaded = false;

    const options = {
        headers: { ...authHeader(), 'Content-Type': 'application/json' }
    }

    export default {
        name: 'AdminCollaborator',
        data() {
            return {
                selectedItem: null,
                skinstories: skinstories,
                loaded: loaded,
                modal: null
            }
        },
        methods: {
            openDeleteModal(item) {
                this.selectedItem = item;
                console.log(item);
                this.modal.show();
            },
            async getData() {
                await axios.get(process.env.VUE_APP_URL + "api/skinstories/all", options)
                    .then(response => {
                        this.loaded = true;
                        this.skinstories = response.data;
                    })
                    .catch(error => {
                        this.$toast(error.message, toastOptions.error);
                    })
                    .finally(() => {
                        this.loaded = true;
                    });
            },
            async deleteItem(item) {
                await axios.delete(process.env.VUE_APP_URL + `api/skinstories/${item.id}`, options)
                    .then(() => {
                        this.$toast("Item deleted", toastOptions.success);
                        this.getData();
                    })
                    .catch(error => {
                        this.$toast(error.message, toastOptions.error);
                    })
            }
        },
        mounted() {
            this.getData();
            this.modal = new Modal(this.$refs.modal);
            
        }
    }
</script>
